import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/event-type",
        component: List,
        name: "event-type-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/event-type/:id/edit",
        component: Edit,
        name: "event-type-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/event-type/create",
        component: Create,
        name: "event-type-create",
        meta: {
            requiresAuth: true,
        },
    },
];
